import { useMemo } from 'react'

import { useRoles } from './useRoles'

export const DISPATCH_ACCESS = {
  view: 'role--operations--dispatch',
  planning: 'role--operations--dispatch--planning',
  conversations: 'role--operations--dispatch--conversations',
  settings: 'role--settings--dispatch',
} as const

export interface IDispatchAccess {
  canView: boolean
  canPlan: boolean
  canConverse: boolean
  canConfigure: boolean
}

export function useDispatchAccess(): IDispatchAccess {
  const { menuItems } = useRoles()

  return useMemo(
    () => ({
      canView: menuItems.has(DISPATCH_ACCESS.view),
      canPlan: menuItems.has(DISPATCH_ACCESS.planning),
      canConverse: menuItems.has(DISPATCH_ACCESS.conversations),
      canConfigure: menuItems.has(DISPATCH_ACCESS.settings),
    }),
    [menuItems],
  )
}
